import React from 'react';
import { loadWithChunkRetry } from '../utils/lazyWithRetry';
import { publicPageForPath } from './publicPageChunks';

// webpackChunkName values must stay in sync with publicPageChunks.js.
const LOADERS = {
  contact: () => loadWithChunkRetry(() => import(/* webpackChunkName: "page-contact" */ '../features/shared/pages/ContactPage')),
  about: () => loadWithChunkRetry(() => import(/* webpackChunkName: "page-about" */ '../features/shared/pages/AboutPage')),
  offers: () => loadWithChunkRetry(() => import(/* webpackChunkName: "page-offers" */ '../features/shared/pages/OffersPage')),
  blogs: () => loadWithChunkRetry(() => import(/* webpackChunkName: "page-blogs" */ '../features/shared/pages/BlogLandingPage')),
  blogPost: () => loadWithChunkRetry(() => import(/* webpackChunkName: "page-blog-post" */ '../features/shared/pages/BlogDetailPage')),
  technicianApply: () => loadWithChunkRetry(() => import(/* webpackChunkName: "page-technician-apply" */ '../features/technician/pages/TechnicianApplyPage')),
  servicesIndex: () => loadWithChunkRetry(() => import(/* webpackChunkName: "page-services" */ '../features/marketing/pages/ServicesIndexPage')),
  serviceDetail: () => loadWithChunkRetry(() => import(/* webpackChunkName: "page-service" */ '../features/marketing/pages/ServiceDetailPage')),
  city: () => loadWithChunkRetry(() => import(/* webpackChunkName: "page-city" */ '../features/marketing/pages/CityPage')),
};

const resolved = Object.create(null);
const pending = Object.create(null);

function loadPage(name) {
  if (resolved[name]) return Promise.resolve(resolved[name]);
  if (!pending[name]) {
    const loader = LOADERS[name];
    if (!loader) return Promise.resolve(null);
    pending[name] = loader()
      .then((mod) => {
        resolved[name] = mod;
        return mod;
      })
      .catch((error) => {
        delete pending[name];
        throw error;
      });
  }
  return pending[name];
}

/**
 * Resolve the route chunk before hydrateRoot or renderToString.
 * React.lazy still suspends once even after import() has settled, so the
 * page component is cached here and rendered synchronously afterwards.
 */
export function preloadPublicPage(pathname) {
  const spec = publicPageForPath(pathname);
  if (!spec) return Promise.resolve(null);
  return loadPage(spec.name);
}

export function PublicPage({ name }) {
  const mod = resolved[name];
  if (!mod) {
    throw loadPage(name);
  }
  const Page = mod.default;
  return <Page />;
}
